import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Modal from 'components/Modal';

import { injectIntl } from 'react-intl';

import { formStatusDispatchHelper } from 'actions/FormStatusActions';
import { addNotification } from 'actions/NotificationsActions';

class OrderPickedUp extends React.Component {
  render() {
    const { intl, show, close, order, formStatus } = this.props;
    const messages = intl.messages;

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            {messages.mark_picked_up}{' '}
            <span class="small hint-text">
              {messages.order} {order.id}
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Button
            bsStyle="primary"
            bsSize="lg"
            block
            disabled={formStatus.pending}
            onClick={() => this.props.onSubmit(order.id)}
          >
            {formStatus.pending ? <i class="fa-fw fa fa-circle-notch fa-spin m-r-5" /> : null}

            {messages.save}
          </Button>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    formStatus: state.formStatus.orderActionPickedUp,
  };
};
const mapDispatchToProps = dispatch => {
  return {
    onSubmit: orderId => {
      formStatusDispatchHelper('orderActionPickedUp', '/api/orders/' + orderId + '/pickedUp.json', {}, 'put', dispatch);
    },
    doNotify: (code, text) => {
      dispatch(addNotification(code, text));
    },
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(OrderPickedUp)
  )
);
